module.exports = __webpack_public_path__ + "static/media/hakkinda.fdc50a6d.png";